export const table_translate = {
  header: {
    actions: 'Ações'
  },
  body: {
    emptyDataSourceMessage: 'Nenhum registro para exibir',
    editRow: {
      deleteText: "Deseja excluir o registro?",
      cancelTooltip: "Cancelar",
      saveTooltip: "Salvar"
    },
    deleteTooltip: "Excluir",
    editTooltip: "Editar"
  },
  toolbar: {
    searchTooltip: 'Pesquisar',
    searchPlaceholder: 'Pesquisar',
    nRowsSelected: '{0} linha(s) selecionada(s)'
  },
  pagination: {
    labelRowsSelect: 'linhas',
    labelDisplayedRows: '{count} de {from}-{to}',
    firstTooltip: 'Primeira página',
    previousTooltip: 'Página anterior',
    nextTooltip: 'Próxima página',
    lastTooltip: 'Última página'
  }
}

export const table_style =
{
  filtering: true,
  exportButton: true,
}